import React, { ChangeEvent } from 'react'
import ModalPreviewEmail from './ModalPreviewEmail/ModalPreviewEmail'
import { PreviewEmail } from '../ConModalResumeScheduleEmail/ModalResumeScheduleNotification/ModalResumeScheduleEmail'

type ConModalPreviewEmailProps = {
    subject: string
    bodyEmail: string
    previewEmail: PreviewEmail
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ConModalPreviewEmail = ({
    subject,
    bodyEmail,
    previewEmail,
    onSubmit,
    onCloseModal,
}: ConModalPreviewEmailProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalPreviewEmail
                                onCloseModal={onCloseModal}
                                subject={subject}
                                bodyEmail={bodyEmail}
                                onSubmit={onSubmit}
                                previewEmail={previewEmail}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalPreviewEmail )